import { isStateForm, setValue } from './state/setValue';
import { proxyStateWithForm, isValidForm } from './state/index';
import proxyIndex from './proxyIndex';


const FORM_API = ['getValue', 'getData', 'forceValid', 'saveResetPoint', 'getFieldData',
  'setData', 'setFieldData', 'setValue', 'clear', 'setBehavior'];

export function defineFormSubmit(ctx, proxy, form) {
  proxy.submit = (url, options) => {
    const value = form.getValue(true);
    return new Promise((resolve, reject) => {
      if (!value.success) {
        reject(value.errorMsg);
        return;
      }
      ctx.fn.fetch({
        url,
        data: value.content,
        ...options,
      }).then((response) => {
        resolve(response);
      }).catch((err) => {
        reject(err);
      });
    });
  };
}

export function proxyFormAPI(proxy, form) {
  FORM_API.forEach((key) => {
    if (!(key in proxy)) {
      proxy[key] = form[key] && form[key].bind(form);
    }
  });
  // isValidate errorMsg
  if (!('isValidate' in proxy)) {
    Object.defineProperty(proxy, 'isValidate', {
      get() {
        return form.getValue().success;
      },
    });
  }
  if (!('errorMsg' in proxy)) {
    Object.defineProperty(proxy, 'errorMsg', {
      get() {
        return form.getValue().errorMsg;
      },
    });
  }
}

export function proxyOwnerForm(ctx, form, scope) {
  if (!isValidForm(form)) {
    return undefined;
  }
  // proxy group
  const proxy = {};
  proxyIndex(proxy, scope);
  proxyFormAPI(proxy, form);
  defineFormSubmit(ctx, proxy, form);
  const result = Object.create(proxy);
  if (form.getItems && form.getItems()) {
    Object.defineProperties(result, {
      items: {
        get() {
          const formItems = {};
          form.getItems().forEach((item) => {
            // use getValue to not cause report as observed
            const key = item.getValue('fieldId');
            Object.defineProperty(formItems, key, {
              get() {
                return proxyStateWithForm({ ctx, state: item });
              },
              set(value) {
                setValue(item, value, item);
              },
            });
          });
          return formItems;
        },
      },
    });
  }
  Object.defineProperties(result, {
    value: {
      get() {
        return form.getValue().content;
      },
      set(value) {
        form.setValue(value);
      },
      enumerable: true,
    },
    behavior: {
      set(value) {
        form.setBehavior(value);
      },
    },
  });
  return result;
}

export function getAndProxyForm(state, context) {
  // 获取 parent form
  const form = state && state.getOwnerForm && state.getOwnerForm();
  if (form) {
    let { owner } = state;
    while (!isStateForm(owner)) {
      ({ owner } = owner);
    }
    if (isStateForm(owner) && owner.owner) {
      return proxyStateWithForm({
        ctx: context,
        state: owner,
        scope: owner.owner,
        form,
      });
    }
  }
  return proxyOwnerForm(context, form);
}
